import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IPartnerSettingsApiClientService {
    getPartnerSettings(partnerCode: string): ng.IPromise<Models.PartnerSettingsModel.IPartnerSettings>;
    getPartnerRelationships(stateCode: string): ng.IPromise<Models.PartnerModel.IPartnerModel[]>;
    getPartnerRelationshipsByPartner(partnerCode: string, stateCode: string): ng.IPromise<Models.PartnerModel.IPartnerModel[]>;
    getPartnersForUserManagement(): ng.IPromise<Models.PartnerModel.IPartnerModel[]>;
}

export class PartnerSettingsApiClientService implements IPartnerSettingsApiClientService {
    public static $inject = ['igs.apiClientService'];

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
    }

    public getPartnerSettings = (partnerCode: string): ng.IPromise<Models.PartnerSettingsModel.PartnerSettings> => {
        var url = `Partner/${partnerCode}/Settings`;
        return this.igsApiClientService.get(url);
    }

    public getPartnerRelationships = (stateCode: string): ng.IPromise<Models.PartnerModel.PartnerModel[]> => {
        var url = `Partner/Relationships/${stateCode}`;
        return this.igsApiClientService.get(url);
    }

    public getPartnerRelationshipsByPartner = (partnerCode: string, stateCode: string): ng.IPromise<Models.PartnerModel.PartnerModel[]> => {
        var url = `Partner/${partnerCode}/Relationships/${stateCode}`;
        return this.igsApiClientService.get(url);
    }

    public getPartnersForUserManagement = (): ng.IPromise<Models.PartnerModel.PartnerModel[]> => {
        var url = `Partner/Relationships/UserMgmt`;
        return this.igsApiClientService.get(url);
    }
}
